<template>
	<div>
		<div class="content">
			<div class="up-content">
				<img src="@/assets/images/my-wallet/pic_recharge_right.png" class="succ-icon">
				<p class="succ-text">已申请提现，请耐心等待管理员审核</p>
				<p class="succ-amount">
					<span class="rmb">¥</span>
					<span class="amount">{{amount}}</span>
				</p>
			</div>
			
			<div class="down-content">
				<div class="title">提现信息</div>
				<div>
					<div class="withdraw-type">
						<img src="@/assets/images/personal/pic_order_cart.png" class="union-icon">
						<span class="type-text">银联</span>
					</div>
					
					<div class="info-wrap">
						<div>
							<div>银行卡名称</div>
							<div>银行卡号</div>
						</div>
						
						<div class="righ-text">
							<div>{{bankName}}</div>
							<div>{{bankCode}}储蓄卡</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'withdrawsucc',
  components: {
    CommonHeader
  },
  data() {
    return {
      isWeixin: false,
      amount: '',
      bankName:"",
      bankCode:""
    }
  },
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
	
  computed: {
    ...mapState(['selected_card'])
  },
  mounted() {
    document.title = "提现"
    const { type, amount,bankName ,bankCode} = this.$route.query;
    this.amount = amount;
    this.bankName = bankName;
    this.bankCode = bankCode;
    if (type=== '1') {
      this.isWeixin = true
    } else {
      this.isWeixin = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.content {
  .f-s(16);
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(51,51,51,1);
  .up-content {
    .m-t(32);
    .m-b(50);
    display: flex;
    flex-direction: column;
    align-items: center;
    .succ-icon {
      .w(56);
      .h(56);
      .m-b(17.5);
    }
    .succ-text {
      .f-s(17);
      .m-b(19);
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(74,144,226,1);
    }
    .succ-amount {
      .rmb {
        .f-s(25);
        .h(35);
        .m-r(15);
      }
      .amount {
        .h(56);
        .l-h(56);
        .f-s(40);
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
    }
  }
  .down-content {
    .p-t(17);
    .m-l(25);
    .m-r(25);
    border-top: 1px solid #cfcfcf;
    .title {
      .f-s(16);
      .l-h(22.5);
      .m-b(17.5);
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .withdraw-type {
      display: flex;
      align-items: center;
      .type-text {
        .m-l(17);
      }
      .weixin-icon {
        .w(30);
        .h(27.5);
      }
      .union-icon {
        .w(33.5);
        .h(21);
      }
    }
    .info-wrap {
      .m-t(20);
      .f-s(14);
      .l-h(20);
      display: flex;
      justify-content: space-between;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(153,153,153,1);
      .right-text {
        color:rgba(51,51,51,1);
      }
    }
  }
}
</style>